var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons 24\\\\\\\\24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clear"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clear_2",
    d: "M19 7.4105L17.5895 6L12 11.5895L6.4105 6L5 7.4105L10.5895 13L5 18.5895L6.4105 20L12 14.4105L17.5895 20L19 18.5895L13.4105 13L19 7.4105Z",
    fill: "#D72525"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveRed);
export default __webpack_public_path__ + "static/media/removeRed.e7e1bc1296bfad1fa9be6fb187ea4095.svg";
export { ForwardRef as ReactComponent };